import { Navigate } from 'react-router-dom'
import { useAuth, SignInPanel } from '@/lib/auth'

export function LoginPage() {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return null
  }

  if (isAuthenticated) {
    return <Navigate to="/overview" replace />
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <SignInPanel />
    </div>
  )
}
